import { render, staticRenderFns } from "./specialty-detail.vue?vue&type=template&id=614635e4&scoped=true&"
import script from "./specialty-detail.vue?vue&type=script&lang=js&"
export * from "./specialty-detail.vue?vue&type=script&lang=js&"
import style0 from "./specialty-detail.vue?vue&type=style&index=0&id=614635e4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614635e4",
  null
  
)

export default component.exports